const PERMISSION_KEY= "company:prompt_gen_ai";
const PAGE_URL = {
    PROMPT_GEN_AI_PAGE: "/admin/company/prompt-gen-ai"
}

export {PERMISSION_KEY, PAGE_URL}

